import { Attachment } from "@wix/wix-ui-icons-common";
import { Node_Type } from "./../ricos-types/index.js";
import { INSERT_PLUGIN_BUTTONS, TOOLBARS } from "./../editor-common/index.js";
import { INSERT_FILE_BUTTON } from "./data-hooks.js";
import { handleFileUpload } from "./handle-file-upload.js";
const toolbarsToAddIn = [
  TOOLBARS.FOOTER,
  TOOLBARS.SIDE,
  TOOLBARS.MOBILE
];
const getAddButtons = (config, services) => {
  return [
    {
      id: Node_Type.FILE,
      label: INSERT_PLUGIN_BUTTONS.FILE,
      dataHook: INSERT_FILE_BUTTON,
      icon: Attachment,
      tooltip: "FileUploadInsertButton_tooltip",
      toolbars: toolbarsToAddIn,
      command: ({ publicCommands }) => {
        handleFileUpload({ services, config, publicCommands });
        return true;
      },
      menuConfig: {
        tags: "UploadFile_plugin_search_tags"
      }
    }
  ];
};
export {
  getAddButtons,
  toolbarsToAddIn
};
//# sourceMappingURL=getAddButtons.js.map
